import classNames from 'classnames';
import React from 'react';
import { Button } from 'reactstrap';
import styles from './styles.module.scss';

type ChildElement = JSX.Element | string;

interface PropTypes {
  active?: boolean;
  className?: string;
  onClick?: () => void;
  children: ChildElement | ChildElement[];
}

export function SurveyButton(props: PropTypes) {
  const color = props.active ? 'primary' : 'secondary';

  return (
    <Button
      color={color}
      className={classNames(
        'rounded-pill',
        'fs-4',
        styles.button,
        props.className,
      )}
      onClick={props.onClick}
    >
      {props.children}
    </Button>
  );
}
